import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SummaryReportService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.summaryReportSubject = new BehaviorSubject([]);
        this.summaryReportObservable = this.summaryReportSubject.asObservable();
    }
    generateReport(analysisId) {
        return this.httpClient.get(environment.api.base + 'summary-reports/' + analysisId, {
            responseType: 'text',
        });
    }
    generateDraftReport(analysisId) {
        return this.httpClient.get(environment.api.base + 'summary-reports/' + analysisId + '/draft', {
            responseType: 'text',
        });
    }
    download(url, type) {
        let params = '?url=' + encodeURIComponent(url) + '&type=' + type;
        return this.httpClient.get(environment.api.baseUpload + 'documents/download' + params, {
            responseType: 'blob',
        });
    }
    completeIcr(analysisId) {
        return this.httpClient.put(environment.api.base + 'icrs/' + analysisId + '/complete', {});
    }
    setGenerateSummaryReport(summaryReport) {
        this.summaryReportSubject.next(summaryReport);
    }
    getGenerateSummaryReport() {
        return this.summaryReportObservable;
    }
}
SummaryReportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SummaryReportService_Factory() { return new SummaryReportService(i0.ɵɵinject(i1.HttpClient)); }, token: SummaryReportService, providedIn: "root" });
